import { getUrl, Request } from "../../request";

import carwash from '../../../assets/svg/car-wash.svg';
import battery from '../../../assets/svg/battery.svg';
import tyre from '../../../assets/svg/tyre.svg';
import oil from '../../../assets/svg/oil.svg';
import filter from '../../../assets/svg/car-parts.svg';


export const getCategories = (city_id, category_id = null, test = false) => {
  if (test) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          data: [{
            "id": 1,
            "name": "Automobile",
            "sub_categories": [ 
              {
                "id": 2,
                "name": "Engine Oil",
                "image": oil,
                "sub_categories": [
                  {
                    "id": 2,
                    "name": "All",
                    "image": "/media/category_images/oil_gNlm6iO.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 8,
                    "name": "Enoc",
                    "image": "/media/category_images/enoc_K5amG1V.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 9,
                    "name": "Lexus",
                    "image": "/media/category_images/Lexus_jZ6UvIT.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 10,
                    "name": "BP",
                    "image": "/media/category_images/BP_31oxulx.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 11,
                    "name": "Toyota",
                    "image": "/media/category_images/toyota.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 12,
                    "name": "Nissan",
                    "image": "/media/category_images/Nissan_7q3qgh8.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 13,
                    "name": "Total",
                    "image": "/media/category_images/total.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 14,
                    "name": "Castrol",
                    "image": "/media/category_images/castrol.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 15,
                    "name": "Mobil 1",
                    "image": "/media/category_images/mobil1.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 16,
                    "name": "LiquiMoly",
                    "image": "/media/category_images/LiquiMoly_JzRfsXb.png",
                    "has_sub_categories": false
                  }
                ],
                "usage_limit_type": "km",
                "order_lines": 0
              },
              {
                "id": 7,
                "name": "Battery",
                "image": battery,
                "sub_categories": [
                  {
                    "id": 2,
                    "name": "All",
                    "image": "/media/category_images/oil_gNlm6iO.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 8,
                    "name": "Enoc",
                    "image": "/media/category_images/enoc_K5amG1V.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 9,
                    "name": "Lexus",
                    "image": "/media/category_images/Lexus_jZ6UvIT.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 10,
                    "name": "BP",
                    "image": "/media/category_images/BP_31oxulx.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 11,
                    "name": "Toyota",
                    "image": "/media/category_images/toyota.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 12,
                    "name": "Nissan",
                    "image": "/media/category_images/Nissan_7q3qgh8.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 13,
                    "name": "Total",
                    "image": "/media/category_images/total.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 14,
                    "name": "Castrol",
                    "image": "/media/category_images/castrol.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 15,
                    "name": "Mobil 1",
                    "image": "/media/category_images/mobil1.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 16,
                    "name": "LiquiMoly",
                    "image": "/media/category_images/LiquiMoly_JzRfsXb.png",
                    "has_sub_categories": false
                  }
                ],
                "usage_limit_type": "km",
                "order_lines": 0
              },
              {
                "id": 4,
                "name": "Tire",
                "image": tyre,
                "sub_categories": [
                  {
                    "id": 2,
                    "name": "All",
                    "image": "/media/category_images/oil_gNlm6iO.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 8,
                    "name": "Enoc",
                    "image": "/media/category_images/enoc_K5amG1V.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 9,
                    "name": "Lexus",
                    "image": "/media/category_images/Lexus_jZ6UvIT.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 10,
                    "name": "BP",
                    "image": "/media/category_images/BP_31oxulx.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 11,
                    "name": "Toyota",
                    "image": "/media/category_images/toyota.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 12,
                    "name": "Nissan",
                    "image": "/media/category_images/Nissan_7q3qgh8.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 13,
                    "name": "Total",
                    "image": "/media/category_images/total.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 14,
                    "name": "Castrol",
                    "image": "/media/category_images/castrol.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 15,
                    "name": "Mobil 1",
                    "image": "/media/category_images/mobil1.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 16,
                    "name": "LiquiMoly",
                    "image": "/media/category_images/LiquiMoly_JzRfsXb.png",
                    "has_sub_categories": false
                  }
                ],
                "usage_limit_type": "km",
                "order_lines": 0
              },
              {
                "id": 6,
                "name": "Filter",
                "image": filter,
                "sub_categories": [
                  {
                    "id": 2,
                    "name": "All",
                    "image": tyre,
                    "has_sub_categories": false
                  },
                ],
                "usage_limit_type": "km",
                "order_lines": 0
              },
              {
                "id": 5,
                "name": "Carwash",
                "image": carwash,
                "sub_categories": [
                  {
                    "id": 2,
                    "name": "All",
                    "image": "/media/category_images/oil_gNlm6iO.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 8,
                    "name": "Enoc",
                    "image": "/media/category_images/enoc_K5amG1V.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 9,
                    "name": "Lexus",
                    "image": "/media/category_images/Lexus_jZ6UvIT.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 10,
                    "name": "BP",
                    "image": "/media/category_images/BP_31oxulx.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 11,
                    "name": "Toyota",
                    "image": "/media/category_images/toyota.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 12,
                    "name": "Nissan",
                    "image": "/media/category_images/Nissan_7q3qgh8.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 13,
                    "name": "Total",
                    "image": "/media/category_images/total.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 14,
                    "name": "Castrol",
                    "image": "/media/category_images/castrol.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 15,
                    "name": "Mobil 1",
                    "image": "/media/category_images/mobil1.png",
                    "has_sub_categories": false
                  },
                  {
                    "id": 16,
                    "name": "LiquiMoly",
                    "image": "/media/category_images/LiquiMoly_JzRfsXb.png",
                    "has_sub_categories": false
                  }
                ],
                "usage_limit_type": "km",
                "order_lines": 0
              },
            ],
            "usage_limit_type": "km",
            "order_lines": 0,
            "parent": ""
          }, 
          {
            "id": 2,
            "name": "Truck",
            "sub_categories": [],
            "usage_limit_type": "km",
            "order_lines": 0,
            "parent": ""
          }, {
            "id": 3,
            "name": "Motorcycle",
            "sub_categories": [],
            "usage_limit_type": "km",
            "order_lines": 0,
            "parent": ""
          }
        ]
        });
      }, 100);
    })
  }

  if (category_id) {
    return new Promise((resolve, reject) => { 
      setTimeout(() => {
        resolve({
          success: true,
          data: [ 
            {
              "id": 2,
              "name": "Engine Oil",
              "image": oil,
              "sub_categories": [
                {
                  "id": 2,
                  "name": "All",
                  "image": oil,
                  "has_sub_categories": false
                },
              ],
              "usage_limit_type": "km",
              "order_lines": 0
            },
            {
              "id": 7,
              "name": "Battery",
              "image": battery,
              "sub_categories": [
                {
                  "id": 2,
                  "name": "All",
                  "image": battery,
                  "has_sub_categories": false
                },
              ],
              "usage_limit_type": "km",
              "order_lines": 0
            },
            {
              "id": 4,
              "name": "Tire",
              "image": tyre,
              "sub_categories": [
                {
                  "id": 2,
                  "name": "All",
                  "image": tyre,
                  "has_sub_categories": false
                },
              ],
              "usage_limit_type": "km",
              "order_lines": 0
            },
            {
              "id": 6,
              "name": "Filter",
              "image": filter,
              "sub_categories": [
                {
                  "id": 2,
                  "name": "All",
                  "image": tyre,
                  "has_sub_categories": false
                },
              ],
              "usage_limit_type": "km",
              "order_lines": 0
            },
            {
              "id": 5,
              "name": "Carwash",
              "image": carwash,
              "sub_categories": [
                {
                  "id": 2,
                  "name": "All",
                  "image": carwash,
                  "has_sub_categories": false
                },
              ],
              "usage_limit_type": "km",
              "order_lines": 0
            },
          ]
        });
      }, 100);
     });
  }
  return Request.get(getUrl("/api/v1/products/categories/"), {
    city_id,
    category_id,
  });
};
